import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, makeStyles, Button } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { ValidatorForm } from 'react-material-ui-form-validator';
import CancelIcon from "@material-ui/icons/Cancel";

import { MesaEntradaStepper } from '../UI/MesaEntradaStepper'
import { MENU_TIPO_EXPEDIENTE, STEPPER_EXPEDIENTE_CONTABLES_FORM, STEPPER_EXPEDIENTE_CONTABLES_PROFORMA_FORM, STEPPER_EXPEDIENTE_FORM, STEPPER_EXPEDIENTE_PROFORMA_FORM, TIPO_EFECTORES } from '../../../utils/constants';
import { TramiteComprobanteForm } from './Form/TramiteComprobanteForm';
import { FormComprobante } from './Form/FormComprobante';
import { setActiveStepMesaEntrada } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { DocumentacionComprobante } from '../UI/Documentacion/DocumentacionComprobante';
import { ImpresionComprobante } from '../UI/ImpresionComprobante';
import { MesaEntradaAccordionProformas } from './Accordions/MesaEntradaAccordionProformas';
import { Save } from '@material-ui/icons';
import { AsientosContablesSelect } from '../UI/AsientosContablesSelect';
import { checkValues } from '../data/datosProformaForm';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: 2,
    textAlign: 'right'
  },
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  title: {
    fontSize: 12,
  },
  iconoTrash: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    color: "#fff",
    backgroundColor: red[500],
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  contenedorTrash: {
    height: 170,
    textAlign: "center",
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  tarjetaReadOnly: {
    pointerEvents: "none",
    opacity: 0.4,
  },
}));

export const StepperFormExpediente = ({ editable, handleSubmit, formValues, ...props }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { activeStep, recepcionMenu, comprobanteTomado, proformas, proformaTomada, menuProforma, tipoEfectorMenu } = useSelector(state => state.mesaEntrada);
  const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);
  const menuPrestador = recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
  const checked = checkValues(formValues);

  const [restoCuenta, setRestoCuenta] = useState(0);

  let stepperMenu = menuProforma && proformas.length > 0 ? STEPPER_EXPEDIENTE_PROFORMA_FORM : STEPPER_EXPEDIENTE_FORM;
  if(cuentas.length > 1){
    if(menuProforma && proformas.length > 0){
      stepperMenu = STEPPER_EXPEDIENTE_CONTABLES_PROFORMA_FORM;
    }else{
      stepperMenu = STEPPER_EXPEDIENTE_CONTABLES_FORM;
    }
  }

  const cleanState = () => {
    dispatch(setActiveStepMesaEntrada(
      cuentas.length > 1 && proformaTomada
      ? stepperMenu.ASIENTOS_CONTABLES
      : proformaTomada || props.cotizacion
        ? stepperMenu.DATOS_COMPROBANTE 
        : stepperMenu.TRAMITE_COMPROBANTE
      ));
  };

  useEffect(() => {
    cleanState();
  }, [props.conEmbargo]);

  const onSubmit = (e) => {
    e.preventDefault();
    // if (tipoEfectorMenu === TIPO_EFECTORES.INTEGRACION && (formValues.cantidad < formValues.cantidadModificada)) {
    //   dispatch(
    //     startAlerta(
    //       "La cantidad modificada no puede ser mayor a la cantidad original",
    //       "error",
    //       "Carga de Comprobante"
    //     )
    //   );
    // }else{
      handleSubmit({...formValues, ...(tipoEfectorMenu === TIPO_EFECTORES.INTEGRACION && { cantidadModificada: parseFloat(formValues.cantidadModificada).toFixed(2) })}, stepperMenu);
    // }
  }

  return (
    <>
      <Grid item xs={12}>
        <MesaEntradaStepper activeStep={activeStep} menuPrestador={menuPrestador} />
      </Grid>
      <ValidatorForm onSubmit={onSubmit}>
        <Grid container spacing={1}>
          {activeStep === stepperMenu.TRAMITE_COMPROBANTE && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <TramiteComprobanteForm
                  formValues={formValues}
                  classes={classes}
                  {...props}
                />
                <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1em' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<CancelIcon />}
                    onClick={() => {props.handleCancel(false)}}
                    className={classes.button}
                  >
                    CANCELAR
                  </Button>
                  <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={formValues?.idTramite !== "" ? false : true}
                      onClick={() => {
                        dispatch(setActiveStepMesaEntrada(
                          menuProforma && proformas.length > 0
                          ? stepperMenu.PROFORMAS_PENDEINTES
                          : stepperMenu.DATOS_COMPROBANTE
                        ))
                      }}
                      className={classes.button}
                  >
                    CONTINUAR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {activeStep === stepperMenu.PROFORMAS_PENDEINTES && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <MesaEntradaAccordionProformas
                    proformas={proformas}
                    onForm
                    formValues={formValues}
                    {...props}
                  />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1em' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => dispatch(setActiveStepMesaEntrada(stepperMenu.TRAMITE_COMPROBANTE))}
                    className={classes.button}
                  >
                    ANTERIOR
                  </Button>
                  <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {
                        dispatch(setActiveStepMesaEntrada(stepperMenu.DATOS_COMPROBANTE))
                      }}
                      className={classes.button}
                  >
                    CONTINUAR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {activeStep === stepperMenu.DATOS_COMPROBANTE && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormComprobante formValues={formValues}
                    handleInputChange={props.handleInputChange}
                    classes={classes}
                    menuPrestador={menuPrestador}
                    setRestoCuenta={setRestoCuenta}
                    {...props} 
                  />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1em' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => {
                      dispatch(setActiveStepMesaEntrada(
                        menuProforma && proformas.length > 0
                        ? stepperMenu.PROFORMAS_PENDEINTES
                        : stepperMenu.TRAMITE_COMPROBANTE
                      ))
                    }}
                    className={classes.button}
                  >
                    ANTERIOR
                  </Button>
                  {cuentas.length > 1 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      onClick={() => {
                        dispatch(setActiveStepMesaEntrada(stepperMenu.ASIENTOS_CONTABLES))
                      }}
                      disabled={!checked}
                    >
                      CONTINUAR
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      startIcon={<Save />}
                      type='submit'
                    >
                      GUARDAR / CONTINUAR
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          {activeStep === stepperMenu.ASIENTOS_CONTABLES && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <AsientosContablesSelect 
                    formValues={formValues}
                    setRestoCuenta={setRestoCuenta}
                    restoCuenta={restoCuenta}
                    {...props}
                  />
                </Grid>
                <Grid item xs={12} style={{textAlign: 'right', marginTop: '1em'}}>
                  <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        dispatch(setActiveStepMesaEntrada(stepperMenu.DATOS_COMPROBANTE))
                      }}
                      className={classes.button}
                  >
                      ANTERIOR
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    type='submit'
                    disabled={parseInt(restoCuenta) !== 0}
                    className={classes.button}
                  >
                    GUARDAR / CONTINUAR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {activeStep === stepperMenu.DOCUMENTACION && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <DocumentacionComprobante idExpediente={comprobanteTomado.idExpediente}
                    menuPrestadorRecepcion={menuPrestador}
                  />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1em' }}>
                  {menuPrestador ?
                    (<Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => dispatch(setActiveStepMesaEntrada(stepperMenu.IMPRESION))}
                      className={classes.button}
                    >
                      CONTINUAR
                    </Button>)
                    :
                    (<Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {props.handleCancel(false)}}
                      className={classes.button}
                    >
                      GUARDAR
                    </Button>)}
                </Grid>
              </Grid>
            </Grid>
          )}
          {menuPrestador && activeStep === stepperMenu.IMPRESION && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <ImpresionComprobante comprobante={comprobanteTomado}
                      titulo
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'right', marginTop: '1em' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => dispatch(setActiveStepMesaEntrada(stepperMenu.DOCUMENTACION))}
                    className={classes.button}
                  >
                    ANTERIOR
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {props.handleCancel(true)}}
                    className={classes.button}
                    startIcon={<Save />}
                  >
                    GUARDAR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </ValidatorForm>
    </>
  )
}
